import angular from 'angular'

import StrictObj from './strict-obj'

import { flow, isUndefined } from 'lodash-es'

angular
  .module('ggs.utils')
  .factory('waitFor', waitForProvider)

function waitForProvider($log, $q, $rootScope, $interval, qh, waitAngularCallback) {
  const REF_EQUAL = false
  const DEEP_EQUAL = true

  const INTERVAL_DELAY = 1e3
  const INTERVAL_INF_LOOP = 0
  const INTERVAL_SKIP_APPLY = false

  const sign2prms = {}

  function waitFor(getValue, testValue, $equalType) {
    const equalType = isUndefined($equalType)
      ? REF_EQUAL
      : $equalType

    const deff = $q.defer()
    const prms = deff.promise

    const safeGet = () => {
      try {
        return getValue()
      } catch (err) {
        _reject(prms, err)
      }
    }
    const safeTest = (val) => {
      try {
        if (!testValue(val)) return
        _resolve(prms, val)
      } catch (err) {
        _reject(prms, err)
      }
    }

    prms._canceled = false
    prms._selfended = false
    prms._deff = deff
    prms._flow = flow(safeGet, safeTest)
    prms._inst = $interval(prms._flow, INTERVAL_DELAY, INTERVAL_INF_LOOP, INTERVAL_SKIP_APPLY)
    prms._woff = $rootScope.$watch(safeGet, safeTest, equalType)
    prms.cancel = () => cancelByPrms(prms)
    waitAngularCallback(prms._flow)
    return prms
  }

  function deep(getValue, testValue) {
    return waitFor(getValue, testValue, DEEP_EQUAL)
  }

  function _resolve(prms, val) {
    _dropSign(prms)
    prms._selfended = true
    $interval.cancel(prms._inst)
    prms._woff()
    prms._deff.resolve(val)
  }

  function _reject(prms, err) {
    _dropSign(prms)
    prms._selfended = true
    $interval.cancel(prms._inst)
    prms._woff()
    prms._deff.reject(err)
  }

  function _cancel(prms, err) {
    _dropSign(prms)
    prms._canceled = true
    $interval.cancel(prms._inst)
    prms._woff()
    prms._deff.reject(err)
  }

  function _dropSign(prms) {
    if (prms._sign) {
      prms._droppedSign = prms._sign
      delete sign2prms[prms._sign]
      delete prms._sign
    }
  }

  function cancelByPrms(prms) {
    if (prms._selfended) {
      $log.debug(new Error('waitFor#cancelByPrms: already selfended - skip!'))
    } else if (prms._canceled) {
      $log.warn(new Error('waitFor#cancelByPrms: already canceled - skip!'))
    } else {
      _cancel(prms, qh.markCanceled(new Error('waitFor#cancelByPrms: action canceled!')))
    }
  }

  function cancellable(sign, getValue, testValue) {
    if (!isUndefined(sign2prms[sign])) {
      throw new Error(`waitFor#cancellable: [sign=${sign}] already registered!`)
    }

    const prms = sign2prms[sign] = waitFor(getValue, testValue)
    prms._sign = sign
    return prms
  }

  function cancelBySign(sign) {
    const prms = sign2prms[sign]
    return isUndefined(prms)
      ? $log.warn(new Error(`waitFor#cancelBySign: [sign=${sign}] not registered - skip!`))
      : cancelByPrms(prms)
  }

  waitFor.deep = deep
  waitFor.cancel = cancelBySign
  waitFor.cancellable = cancellable
  return StrictObj(waitFor)
}
